import Head from "next/head";
import { useEffect, useState } from "react";

interface WebflowPageHeadProps {
  title: string;
  stylesheets: string[];
}

const WebflowPageHead = ({ title, stylesheets }: WebflowPageHeadProps) => (
  <>
    <Head>
      <title>{title}</title>
      {stylesheets.map((link, i) => (
        <link rel="stylesheet" href={link} key={`webflow_head_${i}`} />
      ))}
    </Head>
  </>
);

interface WebflowPageProps {
  html: any;
}

export const WebflowPage = ({ html }: WebflowPageProps) => {
  const [body, setBody] = useState<string>("");

  // This can probably be removed later
  // Prevents a hydration error in development
  useEffect(() => {
    if (process.env.NODE_ENV === "development") {
      // We are in development mode
      setBody(html.body);
    }
  }, [html]);

  return (
    <>
      <WebflowPageHead title={html.title} stylesheets={html.stylesheets} />
      <div
        dangerouslySetInnerHTML={{
          __html: process.env.NODE_ENV === "development" ? body : html.body,
        }}
      />
    </>
  );
};
